import {
  GET_CONSTRUCTION_PROJECTS,
  GET_CONSTRUCTION_PROJECT,
  CREATE_CONSTRUCTION_PROJECT,
  UPDATE_CONSTRUCTION_PROJECT,
  DELETE_CONSTRUCTION_PROJECT,
  UPDATE_PROJECT_PROGRESS,
  GET_PROJECT_DASHBOARD
} from '../actions/constructionActions';

const initialState = {
  projects: [],
  project: null,
  dashboard: null,
  numberOfPages: 0,
  currentPage: 1,
  isLoading: false
};

const constructionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONSTRUCTION_PROJECTS:
      return {
        ...state,
        projects: action.payload.projects,
        numberOfPages: action.payload.totalPages,
        currentPage: action.payload.currentPage,
        isLoading: false
      };
      
    case GET_CONSTRUCTION_PROJECT:
      return {
        ...state,
        project: action.payload,
        isLoading: false
      };
      
    case CREATE_CONSTRUCTION_PROJECT:
      return {
        ...state,
        projects: [action.payload, ...state.projects]
      };
      
    case UPDATE_CONSTRUCTION_PROJECT:
    case UPDATE_PROJECT_PROGRESS:
      return {
        ...state,
        projects: state.projects.map(project => 
          project._id === action.payload._id || project._id === action.payload.project?._id
            ? action.payload.project || action.payload 
            : project
        ),
        project: action.payload.project || action.payload
      };
      
    case DELETE_CONSTRUCTION_PROJECT:
      return {
        ...state,
        projects: state.projects.filter(project => project._id !== action.payload)
      };
      
    case GET_PROJECT_DASHBOARD:
      return {
        ...state,
        dashboard: action.payload,
        isLoading: false
      };
      
    default:
      return state;
  }
};

export default constructionReducer;
